import { useConversationFiltersContext } from '../context/ConversationFiltersContext';
import useGetConversationsQuery from '../queries/useGetConversationsQuery';

const useFetchConversations = () => {
  const { conversationFilters } = useConversationFiltersContext();
  const { data, isLoading, error, refetch } =
    useGetConversationsQuery(conversationFilters);

  return { data, isLoading, error, refetch };
};

export default useFetchConversations;
